import React from "react";
import { Helmet } from "react-helmet";
import "./App.css";
import WormholeConnect, {
  WormholeConnectConfig,
  WormholeConnectTheme,
} from "@wormhole-foundation/wormhole-connect";

function App() {
  const config: WormholeConnectConfig = {
    network: "Mainnet",
    chains: ["Solana", "Bsc"],
    rpcs: {
      Solana:
        "https://node.playsolana.com/b979a26ab8fac7a8a5e67c2391de90bfa670f39d",
      Bsc: "https://long-warmhearted-tab.bsc.quiknode.pro/1a7d27d9bf530cb66db8588b3f64c1377da54cf9",
    },
    tokensConfig: {
      MONKY: {
        key: "MONKY",
        symbol: "MONKY",
        nativeChain: "Bsc",
        tokenId: {
          chain: "Bsc",
          address: "0x59e69094398afbea632f8bd63033bdd2443a3be1",
        },
        coinGeckoId: "wise-monkey",
        icon: "/MONKY.png",
        decimals: 18,
      },
    },
    wrappedTokens: {
      MONKY: {
        Solana: "Evjc9g3AQeDNcE9HnenYnthTC7rKKTDvrKBdeJEMgi16",
      },
    },
    ui: {
      title: "PlaySolana Bridge",
    },
  };

  const theme: WormholeConnectTheme = {
    mode: "dark",
    input: "#181a2d",
    primary: "#9E77ED",
    secondary: "#667085",
    text: "#ffffff",
    textSecondary: "#79859e",
    error: "#F04438",
    success: "#12B76A",
    badge: "#010101",
    font: '"Retro Gaming", sans-serif',
  };

  return (
    <div className="App">
      <Helmet>
        {/* Standard HTML title */}
        <title>PlaySolana Bridge</title>

        {/* Basic description for search engines */}
        <meta
          name="description"
          content="Bridge your tokens easily with PlaySolana"
        />

        {/* Open Graph / Facebook / Twitter metadata */}
        <meta property="og:title" content="PlaySolana Bridge" />
        <meta
          property="og:description"
          content="Bridge your tokens easily with PlaySolana"
        />
        {/* The absolute or root-relative path to your image in /public */}
        <meta
          property="og:image"
          content="https://bridge.playsolana.com/bridge-preview.png"
        />
        <meta property="og:type" content="website" />

        {/* Optional: For Twitter cards */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="PlaySolana Bridge" />
        <meta
          name="twitter:description"
          content="Bridge your tokens easily with PlaySolana"
        />
        {/* Must be absolute URL if you plan on Twitter picking it up. 
            If your domain is e.g. https://playsolana.com, you could do: 
            content="https://playsolana.com/bridge-preview.png" 
        */}
        <meta
          name="twitter:image"
          content="https://bridge.playsolana.com/bridge-preview.png"
        />
      </Helmet>
      <div className="bridge-container">
        <WormholeConnect config={config} theme={theme} />
      </div>
    </div>
  );
}

export default App;
